import {combineReducers} from 'redux';
import {ActionTypes} from 'utils/constants.jsx';

function filters(state = {}, action) {
    const nextState = {...state};

    switch (action.type) {
        case 'CALL_RECORDING_FILTER': {
            return action.data;
        }
        default:
            return state;
    }
}

function filters_applied(state = false, action) {
    switch (action.type) {
        case ActionTypes.CALL_RECORDING_FILTERS_APPLIED: {
            return action.data;
        }
        default:
            return state;
    }
}

export default combineReducers({
    filters,
    filters_applied,
});
